import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import {
    axiosEditPlacedOrder,
    axiosReOrderCartUpdate,
    axiosReOrderSettings,
    axiosViewOrderSettings,
} from '../../actions/orderActions';
import { handleAxiosErrors } from '../../_utils';
import CheckoutConfirmation from '../Checkout/CheckoutConfirmation';
import { getCartData } from '../../actions/cartActions';
import Axios from 'axios';
import { useDispatch, useStore } from 'react-redux';
import { object } from '@storybook/addon-knobs';
import Tooltip from '../ProductTagWizard/Elements/Tooltip';
import TooltipReorder from '../ProductTagWizard/Elements/Tooltip/ToolTipReOrder';
import $ from 'jquery';

const OrderDetailManager = (props) => {
    const { memberType, memberID, cartStore, reOrderTagEditor } = props;
    const orderID = window.orderid || null;

    // State Manager
    const [orderDetails, setOrderDetails] = useState(false);
    const [isOrderLoading, toggleOrderLoading] = useState(false);
    const [isEditOrderLoading, toggleEditOrderLoading] = useState(false);
    const [isOrderByBehalf, setOrderByBehalf] = useState(false);
    const [disableButton, setDisbaledButton] = useState(false);
    const [childMemberID, setChildMemeberID] = useState('');
    const [canProcessBackOrder, setCanProcessBackOrder] = useState(false);

    const backOrdered = !!window.BackOrdered;

    const {
        ID,
        LastEdited,
        OperatorCode,
        Approved,
        Voided,
        BuyerContacted,
        ResellerPurchaseOrder,
        CanCurrentUserEditOrder = false,
        CanCurrentUserDoActionsOnOrder = false,
        PaymentMethod = '',
    } = orderDetails;

    console.log("OrderDetails ==> ", orderDetails);

    // Check if we are displaying this
    const displayForm =
        orderID && (CanCurrentUserEditOrder || CanCurrentUserDoActionsOnOrder);

    // Functions
    const convertData = (data) => {
        if (data === null) {
            return data;
        }

        return {
            ...data,
            CanCurrentUserEditOrder: data.CanCurrentUserEditOrder === 'true',
            CanCurrentUserDoActionsOnOrder:
                data.CanCurrentUserDoActionsOnOrder === 'true',
        };
    };
    const showUpdateFreightButton = window.memberType == 'Wholesaler' && PaymentMethod == 'order-account' && (((window.orderstatus == 'Awaiting Fulfilment' || window.orderstatus == 'In Production' || window.orderstatus == 'Production Complete') && !backOrdered) || (!canProcessBackOrder && CanCurrentUserEditOrder === true));

    const onEditOrderClick = (e) => {
        e.preventDefault();
        toggleEditOrderLoading(true);

        return axiosEditPlacedOrder(orderID)
            .then((response) => {
                if (response.data.data.editPlacedOrder) {
                    window.location.reload();
                }
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .then(() => {
                toggleEditOrderLoading(false);
            });
    };

    const onUpdateFreightClick = () => {
        $('#order-calculation-section').hide();
        $('#update-order-freight-section').show();
    }

    const reOrder = (e) => {
        e.preventDefault();
        toggleEditOrderLoading(true);
        reOrderTagEditor(orderID);
    };

    const request = async () => {
        toggleOrderLoading(true);
        await axiosViewOrderSettings(orderID)
            .then((response) => {

                setOrderDetails(
                    convertData(response.data.data.readOneCartOrder)
                );

                console.log('SetORderDetails =====================> ', orderDetails);
                const excludeOfficialItems = response.data.data.readOneCartOrder.Items.edges.every(
                    (item) => {
                        return item?.node?.Buyable?.OfficialType != null;
                    }
                );
                if (window.CurrentMember) {
                    // if (
                    //     window.CurrentMember !==
                    //     response.data.data.readOneCartOrder.Member.ID
                    //     //&& window.memberType == 'Reseller'
                    // ) {
                    //     setDisbaledButton(true);
                    // }

                }

                if (excludeOfficialItems) {
                    setDisbaledButton(true);
                }
                setChildMemeberID(
                    response.data.data.readOneCartOrder.Member.ID
                );

            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .then(() => {
                toggleOrderLoading(false);
            });
    };

    const orderRejected = async () => {
        setCanProcessBackOrder(false);
    }
    // Hooks
    useEffect(() => {
        request();
        setCanProcessBackOrder(!!window.canProcessBackOrder);
    }, []);

    if (!displayForm && window.orderstatus === 'Dispatched') {
        return (
            <>
                <div
                    className={`${window.memberType == 'Customer' ||
                        window.memberType == 'Retailer' || (window.memberType == 'Reseller' && window.orderBusinessName == 'RCAU Business Name')
                        ? ''
                        : 'card card--border card--form card--stackable'
                        } `}
                >
                    {isOrderLoading === true ? (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                zIndex: 100,
                                background: 'rgba(255,255,255,0.7)',
                                textAlign: 'center',
                                transform: 'translate(-50%, -50%)',
                            }}
                        >
                            <ReactLoading
                                type='spin'
                                color='black'
                                height={50} return
                                width={50}
                            />
                        </div>
                    ) : (
                        !disableButton && (
                            <div className='vspace--small'>
                                <button
                                    type='button'
                                    disabled={disableButton}
                                    className='button btn-reorder'
                                    onClick={reOrder}
                                    style={
                                        disableButton
                                            ? {
                                                opacity: 0.35,
                                                position: 'relative',
                                            }
                                            : { position: 'relative' }
                                    }
                                >
                                    <span
                                        style={{
                                            opacity:
                                                isEditOrderLoading === true
                                                    ? 0
                                                    : 1,
                                        }}
                                    >
                                        ReOrder
                                    </span>
                                    <TooltipReorder
                                        placement='right'
                                        trigger='hover'
                                        tooltip={`REORDER function is only applicable for non-mandatory identification items ordered previously. All items will be added to cart where you will be able to change ${window.localeCountry ==
                                            'United States' ||
                                            window.localeCountry == 'Canada'
                                            ? 'colors'
                                            : 'colours'
                                            }  and quantities. Any previously ordered mandatory identification items will automatically be removed from the REORDER function items added to cart.`}
                                    >
                                        <div className='field-tooltip'>?</div>
                                    </TooltipReorder>
                                    {isEditOrderLoading === true && (
                                        <ReactLoading
                                            className='button__spinner'
                                            type='spin'
                                            color='white'
                                            height={20}
                                            width={20}
                                        />
                                    )}
                                </button>
                            </div>
                        )
                    )}
                </div>
            </>
        );
    }

    return (
        <div
            className={`${CanCurrentUserEditOrder === true ||
                window.orderstatus === 'Dispatched' || (window.memberType == 'Reseller' && window.orderBusinessName == 'RSAU Business Name')
                ? 'card card--border card--form card--stackable'
                : ''
                } `}
        >
            {isOrderLoading === true && (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        zIndex: 100,
                        background: 'rgba(255,255,255,0.7)',
                        textAlign: 'center',
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    <ReactLoading
                        type='spin'
                        color='black'
                        height={50}
                        width={50}
                    />
                </div>
            )}
            <div className='vspace'>
                {!canProcessBackOrder && CanCurrentUserEditOrder === true && (
                    <>
                        <button
                            type='button'
                            className='button'
                            onClick={onEditOrderClick}
                            style={{ position: 'relative' }}
                        >
                            <span
                                style={{
                                    opacity: isEditOrderLoading === true ? 0 : 1,
                                }}
                            >
                                Edit Order
                            </span>
                            {isEditOrderLoading === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>

                    </>
                )}
                {showUpdateFreightButton && (
                    <button
                        type='button'
                        className='button'
                        onClick={onUpdateFreightClick}
                    >
                        <span>
                            Update Freight
                        </span>
                    </button>

                )}


                {canProcessBackOrder && (
                    <button
                        type='button'
                        className='button'
                        onClick={onEditOrderClick}
                        style={{ position: 'relative' }}
                    >
                        <span
                            style={{
                                opacity: isEditOrderLoading === true ? 0 : 1,
                            }}
                        >
                            Process
                        </span>
                        {isEditOrderLoading === true && (
                            <ReactLoading
                                className='button__spinner'
                                type='spin'
                                color='white'
                                height={20}
                                width={20}
                            />
                        )}
                    </button>


                )}
                {window.orderstatus === 'Dispatched' && (
                    <>
                        {isOrderLoading === true ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    zIndex: 100,
                                    background: 'rgba(255,255,255,0.7)',
                                    textAlign: 'center',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                <ReactLoading
                                    type='spin'
                                    color='black'
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            !disableButton && (
                                <button
                                    disabled={disableButton}
                                    className='button btn-reorder'
                                    onClick={reOrder}
                                    style={
                                        disableButton
                                            ? {
                                                opacity: 0.35,
                                                position: 'relative',
                                            }
                                            : { position: 'relative' }
                                    }
                                >
                                    <span
                                        style={{
                                            opacity:
                                                isEditOrderLoading === true
                                                    ? 0
                                                    : 1,
                                        }}
                                    >
                                        ReOrder
                                    </span>
                                    <TooltipReorder
                                        placement='right'
                                        trigger='hover'
                                        tooltip={`Re-Order function is only applicable for non-mandatory identification items ordered previously. All items will be added to cart where you will be able to change ${window.localeCountry ==
                                            'United States' ||
                                            window.localeCountry == 'Canada'
                                            ? 'colors'
                                            : 'colours'
                                            }  and quantities. Any previously ordered mandatory identification items will automatically be removed from the re-order items added to cart.`}
                                    >
                                        <div className='field-tooltip'>?</div>
                                    </TooltipReorder>
                                    {isEditOrderLoading === true && (
                                        <ReactLoading
                                            className='button__spinner'
                                            type='spin'
                                            color='white'
                                            height={20}
                                            width={20}
                                        />
                                    )}
                                </button>
                            )
                        )}
                    </>
                )}
            </div>

            {!backOrdered && (
                <div className='vspace--small'>
                    <CheckoutConfirmation
                        key={LastEdited}
                        orderid={ID}
                        showActions={
                            CanCurrentUserDoActionsOnOrder === true ? 1 : 0
                        }
                        canProcessBackOrder={canProcessBackOrder}
                        approveDate={Approved}
                        rejectDate={Voided}
                        buyerContactedDate={BuyerContacted}
                        initialOperatorCode={OperatorCode}
                        initialResellerPurchaseOrder={ResellerPurchaseOrder}
                        memberType={memberType}
                        requestCallback={request}
                        orderRejectedCallBack={orderRejected}
                    />
                </div>
            )}
        </div>
    );
};

export default OrderDetailManager;
